const ORDER_ID_KEY = 'association_order_id'

export const getOrderId = (): number | null => {
  try {
    const orderId = localStorage.getItem(ORDER_ID_KEY)
    return orderId ? parseInt(orderId, 10) : null
  } catch (error) {
    console.error('Error reading order ID from localStorage:', error)
    return null
  }
}

export const setOrderId = (orderId: number): void => {
  try {
    localStorage.setItem(ORDER_ID_KEY, orderId.toString())
  } catch (error) {
    console.error('Error saving order ID to localStorage:', error)
  }
}

export const clearOrderId = (): void => {
  try {
    localStorage.removeItem(ORDER_ID_KEY)
  } catch (error) {
    console.error('Error clearing order ID from localStorage:', error)
  }
}
